import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import sha256 from 'crypto-js/sha256';


function GoogleReview({ link, Done, setDone }) {
    const { t } = useTranslation();

    const apiUrl = process.env.REACT_APP_BACKEND_URL
    const ImageUrl = process.env.REACT_APP_IMAGES_URL
    const frontEndUrl = process.env.REACT_APP_REACT_URL


    let userId = Cookies.get('userId');
    let UserToken = Cookies.get('UserSpecialToken');
    let IdEntreprise = Cookies.get('IdEntreprise');

    const hashedUserId = sha256((String(userId)));

    let LanguageSelected = Cookies.get('LanguageSelected');

    const [GoogleModal, setGoogleModal] = useState(false)
    const [ReviewLink, setReviewLink] = useState('')


    const [isFetching, setisFetching] = useState(false)

    const [InputsErrors, setInputsErrors] = useState([])




    function GoogleLink() {
        fetch(`${apiUrl}/SaveGoogleReviewLink`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", 'Authorization': `Bearer ${UserToken}`
            },
            body: JSON.stringify({ user_id: hashedUserId, linkGoogle: ReviewLink })
        })
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    setInputsErrors([])
                    setGoogleModal(false)
                    setReviewLink(result.googleLinkReview)
                    setDone(!Done)
                    toast.success(result.message, {
                        position: toast.POSITION.CENTER
                    });
                } else {
                    setInputsErrors(result.errors)

                }
            })
    }



    return (
        <div>
            <button onClick={() => setGoogleModal(true)} type="submit" className="w-full font-semibold relative text-theme flex justify-start items-center mt-3 p-3 py-2 px-4 border border-transparent rounded shadow-sm text-sm font-medium text-black sections h-16  hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={`${LanguageSelected == 'ar' ? 'w-6 ml-3 ' : 'w-6 mr-3 '}`}                                                                             >
                    <path
                        d="M6 12C6 15.3137 8.68629 18 12 18C14.6124 18 16.8349 16.3304 17.6586 14H12V10H21.8047V14H21.8C20.8734 18.5645 16.8379 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C15.445 2 18.4831 3.742 20.2815 6.39318L17.0039 8.68815C15.9296 7.06812 14.0895 6 12 6C8.68629 6 6 8.68629 6 12Z"
                        fill="currentColor"
                    />
                </svg>
                {t("Add google reveiw")}
            </button>

            {GoogleModal &&
                <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
                    <div className="relative w-full max-h-screen findservice overflow-hidden -mt-10 rounded-xl  div-sections">
                        <div className="absolute -top-2 -right-2 p-4">
                            <a className='w-8 h-8' onClick={() => { setGoogleModal(false) }}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                </svg>
                            </a>
                        </div>
                        <div className="w-full settingswidth ">
                            <div className={`${LanguageSelected == 'ar' ? 'pl-6 ' : 'pr-6'}`} >
                                <div className="flex  items-center justify-start ">
                                    <p className="text-2xl text-gold px-3 py-2 font-bold">{t("Google Review")}</p>
                                </div>
                            </div>
                            <div>
                                <div className='grid place-items-center w-full py-4 gap-4 px-4'>
                                    <>
                                        <div className=" w-full">
                                            <textarea rows={4} defaultValue={link} onChange={(e) => setReviewLink(e.target.value)} type="text" id="linkGoogle" name="linkGoogle" className="appearance-none block placeholder-sm  w-full px-3 py-2 bg-gray-700 border-2 border-gold rounded placeholder-gray-111 text-black  focus:outline-none active  sm:text-sm" placeholder={t("Google Review Link")} required ></textarea>
                                            <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('linkGoogle') && InputsErrors.linkGoogle}</span></p>

                                        </div>
                                        <button onClick={(e) => GoogleLink()} disabled={isFetching} type="submit" className={`w-full  btn-edit`}>
                                            {isFetching ?
                                                (<svg class="w-4 h-4 text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                                    <path
                                                        d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                                                        stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path
                                                        d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                                                        stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-900">
                                                    </path>
                                                </svg>)
                                                : (
                                                    t('Confirm')
                                                )
                                            }

                                        </button>
                                    </>

                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            }
        </div>
    )
}

export default GoogleReview